import { UBT } from '@hb/tianqi/lib/ubt.h5';
import pkg from '../../package.json';

UBT.config({
  env: process.env.REACT_APP_ENV,
  debug: process.env.REACT_APP_ENV !== 'pro',
  categoryId: 'evbike',
  history: false,
});

UBT.bindData({
  appVersion: pkg.version,
  appName: 'AppEvBikeMiniProH5',
});

export default UBT;
